module.exports = __webpack_public_path__ + "img/electricien_panneaux_electrique.3f45893d.jpg";